<mat-form-field class="additional-customers-filter-table__search-input">
  <mat-icon matPrefix>search</mat-icon>
  <input matInput
    type="text"
    [(ngModel)]="searchTerm"
    [placeholder]="placeHolderText"
    [attr.data-testid]="dataTestId"
    (keyup)="searchTermChange.emit(searchTerm); searchTable.emit(searchTerm)">
  @if (searchTerm?.length > 0) {
    <button type="button" matSuffix class="cfa-plain-button cfa-plain-button--inline" aria-label="Clear search" (click)="clearSearch.emit()">
      <mat-icon>close</mat-icon>
    </button>
  }
</mat-form-field>
<ng-content></ng-content>
<button mat-button class="additional-customers-filter-table__remove-button" (click)="removeSelected.emit()">
  {{ removeButtonText }}
</button>

